export const githubOauthPopupEventType = 'agentteams:github-oauth-complete';

export const openGithubOauthPopup = (url: string): Window | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  const width = 640;
  const height = 760;
  const left = Math.max(0, Math.round((window.screen.width - width) / 2));
  const top = Math.max(0, Math.round((window.screen.height - height) / 2));

  const features = [
    `width=${width}`,
    `height=${height}`,
    `left=${left}`,
    `top=${top}`,
    'popup=yes',
    'resizable=yes',
    'scrollbars=yes',
  ].join(',');

  const popup = window.open(url, 'agentteams-github-oauth', features);
  if (!popup) {
    return null;
  }

  popup.focus();
  return popup;
};

export const buildGithubOauthPopupRedirectPath = (nextPath: string): string => {
  const normalizedNextPath = nextPath.startsWith('/') ? nextPath : '/';
  return `/auth/github-popup-complete?next=${encodeURIComponent(normalizedNextPath)}`;
};
